import React from 'react'
import Select from './Select'

export const STATUSES = [
  { id: 'all', name: 'Billed: all' },
  { id: 'true', name: 'Billed' },
  { id: 'false', name: 'Not billed' },
]

export default function BilledStatusSelect(props) {
  return <Select {...props} options={STATUSES} />
}
